import { Button, CircularProgress, Grid } from '@material-ui/core';
import { min } from 'date-fns';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import CustomUserMenu from '../../commons/CustomUserMenu';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import ListaEvaluatori from './ListaEvaluatori';
import WsC from './providers/WsC';



export default class EvaluareNouaColegi extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            tipEvaluare: 0,
            tipuriEvaluare: this.u.tipuriEvaluare,
            departamente: [],
            chestionare: [],
            userEvaluat: {
                id: null, poza: null
            },
            useri: [],
            openList: false,
            departamentSelectat: 0,
            formularSelectat: 0,
            angajatiSelectati: 0,
            creeazaEvaluareDisabled: true,
            chestionarSelectat: 0,
            idxDepartament: -1,
            ultimaEvaluare: null,
            objMin: {},
            loading: false,
            userNotInList:{},
            alertView:false,
            idSocietate:0
        }
    }


    u = new Utils()
    wsC = new WsC()
    ws = new Ws()
    ls = new LocalStorage().GetUserData()

    componentDidMount() {
        this.access()
        this.getData()
    }

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }

    getData = async () => {

        let getSocietate = await this.ws.customSelect('select * from setari', {
            p1: 'soc_code'
        })

        if (getSocietate.Succes) {
            let _departamente = this.ws.customSelect(`select d.id, d.poza, d.nume, d.[level], d.id_parent, o.[margintop], o.[marginleft], o.[width],
        o.[height], o.color from departamente d left outer join organigrama_display_data o
         on (d.id = o.id_departament) where isnull(d.inactiv,0) != @p1 and marginLeft > 0 `, {
                p1: 1
            })



            let _angajati = this.ws.customSelect(`select
                        a.id , dep.id as id_departament, u.id as id_user,
                        l.parola, l.parolac, l.email as email_logator, l.id_user_bazadate_proprie,
                        ad.sef_departament,a.cnp,a.adresa,a.telefon,
                        a.nume, a.poza, a.cost_minut, a.functie,a.oras, a.salariu, a.doc_fisa_postului,a.cv, u.email, u.firma, u.is_admin, dep.nume as nume_departament  from  useri u
                        left join angajati a on u.id = a.id_user 
                        left join angajati_departamente ad on ad.id_angajat = a.id
                        left join departamente dep on dep.id = ad.id_departament
                        left join pm_logator.[dbo].useri l on u.id = l.id_user_bazadate_proprie
                        where isnull(u.inactiv,0) != 1 and l.id_societate_client = @p2 and isnull(ad.inactiv,0) != 1 and isnull(a.inactiv,0) !=1  and isnull(u.inactiv,0 ) != 1 order by a.nume asc`, {
                p1: 1,
                p2: getSocietate.Content.length > 0 ? Number(getSocietate.Content[0].val) : 1
            })


            let chestionare = await this.wsC.customSelect(`select u.nume as nume_utilizator,  c.* , (select count(*) from chestionare_intrebari where id_chestionar = c.id and isnull(id_parent,0) = 0) as nr_intrebari 
        from chestionare c left join [${this.ls.InfoUser.Database}].[dbo].[useri] u on c.creat_de = u.id  where c.baza_date = @p1 and isnull(c.sters,0) != 1`,
                { p1: this.ls.InfoUser.Database })


            let evaluare = await this.wsC.customSelect(`select e.*, c.id_chestionar from evaluari e left join evaluari_chestionare c 
                                                            on e.id = c.id_evaluare where e.id = @p1  `, {
                p1: this.props.match.params.idevaluare
            })

            let getEmailuri = await this.wsC.customSelect('select * from evaluari_emailuri where id_evaluare = @p1', {
                p1: this.props.match.params.idevaluare
            })




            let [d, a, c, e, em] = await Promise.all([_departamente, _angajati, chestionare, evaluare, getEmailuri])
            console.log('d :>> ', d);
            console.log('a :>> ', a);
            console.log('e :>> ', e);
            console.log('em :>> ', em);

            if (d.Succes && a.Succes && c.Succes && e.Succes && em.Succes) {

                console.log('useri :>> ', a.Content);

                let cloneA = [...a.Content]

                console.log('this.ls.IdUser :>> ', this.ls.InfoUser.IdUser);

                cloneA = cloneA.filter(ang => Number(ang.id_user) !== Number(this.ls.InfoUser.IdUser))



                let emailuri = [...em.Content]

                let rez = []

                let depts = d.Content

                let counter = depts.length

                let userEvaluat = {}

                let useriEvaluatori = []


                for (let j = 0; j < counter; j++) {

                    let angajati = a.Content.filter(a => a.id_departament === depts[j].id && a.sef_departament !== 1)



                    for (let k = 0, m = angajati.length; k < m; k++) {

                        useriEvaluatori.push(angajati[k])

                        let idx = emailuri.findIndex(email => email.id_angajat === angajati[k].id)


                        if (idx !== -1) {
                            angajati[k].selectat = true
                        } else {

                            angajati[k].selectat = false
                        }


                        if (e.Content[0]) {
                            if (angajati[k].id_user === e.Content[0].id_user_aprobare) {
                                userEvaluat = angajati[k]
                            }
                        }

                        angajati[k].disabled = false

                    }


                    depts[j].selectat = false
                    depts[j].expandat = false
                    depts[j].angajati = angajati




                }

                console.log('depts :>> ', depts);

                console.log('userEvaluat :>> ', userEvaluat);

                depts = depts.filter(dept => dept.angajati.length > 0)


                let evData = await new LocalStorage().GetEvaluareData()

               

                console.log('evData :>> ', evData);

                if (evData) {

                    evData['chestionare'] = c.Content

                    this.setState(evData, async () => {
                        await localStorage.removeItem('localEvKey')
                    })

                } else {

                    if (Number(this.props.match.params.idevaluare) === 0) {
                        this.setState({
                            departamente: depts,
                            userEvaluat: {
                                id: 0,
                                id_user: 0,
                                nume: "",
                                poza: null,
                            },
                            useri: a.Content.filter(a => a.id_departament !== null),
                            chestionare: c.Content,
                            tipEvaluare: Number(this.props.match.params.idevaluare) !== 0 ? 1 : 0,
                            idSocietate:getSocietate.Content[0].val
                        })
                    } else {





                        console.log('getEmailuri :>> ', getEmailuri);



                        this.setState({
                            departamente: depts,
                            userEvaluat: userEvaluat,
                            chestionarSelectat: e.Content[0].id_chestionar,
                            useri: a.Content.filter(a => a.id_departament !== null),
                            chestionare: c.Content,
                            tipEvaluare: Number(this.props.match.params.idevaluare) !== 0 ? 1 : 0,
                            evaluare: e.Content[0],
                            emailuriEvaluare: em.Content,
                            angajatiSelectati: em.Content.length,
                            creeazaEvaluareDisabled: false,
                            idSocietate:getSocietate.Content[0].val
                        })

                    }

                }




            }
        }
    }


    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }


    dataAzi = () => {


        let dataAzi = this.u.defaultData()

        if (this.dictionary.date === 'en') {
            return this.u.dataPrescurtataEng(dataAzi)
        } else {
            return this.u.dataPrescurtataRomana(dataAzi)
        }
    }


    changeTipEvaluare = async (ev) => {


        let val = ev.target.value

        let disabled = true

        console.log('val :>> ', val);

        let objMin = {}

        if (Number(val) === 3) {
            if (Number(this.state.chestionarSelectat) > 0) {
                disabled = false
            } else {
                disabled = true
            }

            let departamente = [...this.state.departamente]

            console.log('departamente :>> ', departamente);

            let min = Math.min.apply(null, departamente.map(function (item) {
                return item.angajati.length;
            }))

            min = Math.ceil(min / 2)


            let minDepartamente = min + departamente.length

            console.log('min :>> ', min);

            objMin = {
                nr_useri_departament: 2,
                nr_useri_departamente:4
            }


            

            console.log('objMin :>> ', objMin);
        }

        let cloneUseri = [...this.state.useri]

        let useriIds = cloneUseri.map((u, idx) => {
            return u.id_user
        })

        console.log('cloneUseri :>> ', cloneUseri);

        let getUltimaEvaluare = await this.wsC.customSelect(`select e.*, (select count(*) from evaluari_emailuri where id_evaluare = e.id) as nr_evaluatori from evaluari e where e.id_user_aprobare in (${useriIds}) order by e.cand_creat desc`,
            { p1: 1 })

        console.log('getUltimaEvaluare :>> ', getUltimaEvaluare);



        let departamente = [...this.state.departamente]


        for(let i = 0 , n = departamente.length; i < n ; i++){

            for(let j = 0 , m = departamente[i].angajati.length ; j< m;  j++){

              
                    departamente[i].angajati[j].disabled = false
                
            }
        }


        if (getUltimaEvaluare.Succes) {
            this.setState({
                tipEvaluare: val,
                creeazaEvaluareDisabled: disabled,
                departamente:departamente,
                objMin: objMin,
                ultimaEvaluare: getUltimaEvaluare.Content[0]
            })
        }




    }

    changeDepartament = async (ev) => {
        let val = ev.target.value

        let disabled = true

        if (Number(this.state.chestionarSelectat) > 0) {
            disabled = false
        }


        let getUltimaEvaluare = await this.wsC.customSelect(`select e.*, (select count(*) from evaluari_emailuri where id_evaluare = e.id) as nr_evaluatori from evaluari e where e.id_departament = @p1 and isnull(e.inactiv,0) != 1 order by e.cand_creat desc`, {
            p1: val
        })

        let idx = this.state.departamente.findIndex(d => Number(d.id) === Number(val))

        if (getUltimaEvaluare.Succes) {
            console.log('getUltimaEvaluare :>> ', getUltimaEvaluare);
            this.setState({
                departamentSelectat: val,
                creeazaEvaluareDisabled: disabled,
                idxDepartament: idx,
                ultimaEvaluare: getUltimaEvaluare.Content[0]
            })
        }


    }


    selectUser = async (u) => {

        let disabled = true

        if (Number(this.state.chestionarSelectat) > 0) {
            disabled = false
        }

        console.log('this.state.chestionarSelectat :>> ', this.state.chestionarSelectat);
        console.log('disabled :>> ', disabled);



        let idx = this.state.departamente.findIndex(d => d.id === u.id_departament)


        let getUltimaEvaluare = await this.wsC.customSelect(`select e.*, (select count(*) from evaluari_emailuri where id_evaluare = e.id) as nr_evaluatori from evaluari e where e.id_user_aprobare = @p1 order by e.cand_creat desc`, { p1: u.id_user })

        console.log('getUltimaEvaluare :>> ', getUltimaEvaluare);


        let departamente = [...this.state.departamente]


        for(let i = 0 , n = departamente.length; i < n ; i++){

            for(let j = 0 , m = departamente[i].angajati.length ; j< m;  j++){

                if( Number(departamente[i].angajati[j].id_user) === Number(u.id_user) ){

                        departamente[i].angajati[j].disabled = true
                }else{
                    departamente[i].angajati[j].disabled = false
                }
            }
        }

        if (getUltimaEvaluare.Succes) {
            this.setState({
                userEvaluat: u,
                idxDepartament: idx,
                creeazaEvaluareDisabled: disabled,
                departamente:departamente,
                ultimaEvaluare: getUltimaEvaluare.Content[0]
            })

        }


    }


    changeChestionar = async (ev) => {

        let val = ev.target.value
        let disabled = true

        if (this.state.userEvaluat.id) {
            disabled = false
        } else if (Number(this.state.departamentSelectat) > 0) {
            disabled = false
        } else if (Number(this.state.tipEvaluare) === 3) {
            disabled = false
        } else if (Number(val) > 0) {
            disabled = false
        }


        if (Number(val) === 0) {
            disabled = true
        }

        console.log('val :>> ', val);

        console.log('this.state.userEvaluat :>> ', this.state.userEvaluat);
        console.log('disabled :>> ', disabled);


        let updateSesiune = await this.wsC.update('sesiuni', { id_chestionar: val }, { id: this.props.match.params.idsesiune })

        if (updateSesiune.Succes) {
            this.setState({
                chestionarSelectat: val,
                creeazaEvaluareDisabled: disabled
            })
        }


    }


    goToChestionare = async () => {


        let evData = await new LocalStorage().SetEvaluareData(this.state)

        this.props.history.push(`/chestionareevaluari/${this.props.match.params.idsesiune}/colegi`)


    }


    selecteazaDepartament = (d) => {

        let departamente = [...this.state.departamente]

        let angajatiSelectati = this.state.angajatiSelectati

        let idx = departamente.findIndex(dep => dep.id === d.id)

        console.log('departamente :>> ', departamente[idx]);

        if (idx !== -1) {

            departamente[idx]['selectat'] = !departamente[idx]['selectat']
            departamente[idx]['expandat'] = departamente[idx]['selectat']



            for (let i = 0, n = departamente[idx].angajati.length; i < n; i++) {


                if (!departamente[idx].angajati[i]['disabled']) {
                    if (departamente[idx].angajati[i]['selectat'] !== departamente[idx]['selectat']) {
                        departamente[idx].angajati[i]['selectat'] = departamente[idx]['selectat']

                        if (departamente[idx].angajati[i]['selectat']) {
                            if (departamente[idx].angajati[i]['selectat']) {
                                angajatiSelectati += 1
                            } else {
                                angajatiSelectati -= 1
                            }
                        } else {
                            angajatiSelectati -= 1
                        }
                    }
                }



            }

            console.log('angajatiSelectati :>> ', angajatiSelectati);






        }

        this.setState({
            departamente: departamente,
            angajatiSelectati: angajatiSelectati
        })
    }



    selecteazaAngajat = (a) => {

        let departamente = [...this.state.departamente]

        let angajatiSelectati = this.state.angajatiSelectati

        let idxDep = departamente.findIndex(dep => dep.id === a.id_departament)

        console.log('idxDep :>> ', idxDep);

        console.log('a :>> ', a);
        if (idxDep !== -1) {
            let idxA = departamente[idxDep].angajati.findIndex(ang => ang.id === a.id)

            if (idxA !== -1) {

                if (!departamente[idxDep].angajati[idxA]['disabled']) {
                    departamente[idxDep].angajati[idxA]['selectat'] = !departamente[idxDep].angajati[idxA]['selectat']
                    if (!departamente[idxDep].angajati[idxA]['selectat'] === false) {

                        angajatiSelectati += 1
                    } else {
                        angajatiSelectati -= 1
                        departamente[idxDep]['selectat'] = false

                    }

                    let filterDep = departamente[idxDep].angajati.filter(ang => ang.selectat)


                    console.log('filterDep :>> ', filterDep);
                    if (departamente[idxDep].angajati.length === filterDep.length) {
                        departamente[idxDep]['selectat'] = true
                    }
                }



            }

            this.setState({
                angajatiSelectati: angajatiSelectati,
                departamente: departamente
            })
        }

    }


    arataUseri = (d) => {
        let departamente = [...this.state.departamente]

        let idx = departamente.findIndex(dep => dep.id === d.id)

        if (idx !== -1) {

            departamente[idx]['expandat'] = !departamente[idx]['expandat']



            this.setState({ departamente: departamente })
        }
    }


    addEvaluare = async () => {


        this.setState({ loading: true }, async () => {
            if (Number(this.props.match.params.idevaluare) === 0) {
                if (Number(this.state.tipEvaluare) === 1) {



                    // let evaluari = await this.wsC.customSelect('select * from evaluari', {
                    //     p1: 0
                    // })

                    // let evaluariChestionare = await this.wsC.customSelect('select * from evaluari_chestionare', {
                    //     p1: 0
                    // })


                    // console.log('evaluari :>> ', evaluari);
                    // console.log('evaluariChestionare :>> ', evaluariChestionare);


                    let objEvaluare = {
                        id_beneficiar: this.state.idSocietate,
                        cand_creat: this.u.updateSqlNow(),
                        cine_creat: this.ls.InfoUser.IdUser,
                        denumire: "",
                        foloseste_puncte: 1,
                        id_sesiune: this.props.match.params.idsesiune,
                        id_user_aprobare: this.state.userEvaluat.id_user,
                        statusul: "lansat",
                        tip: "evaluare_angajati",
                        id_departament: this.state.userEvaluat.id_departament,
                    }

                    console.log('objEvaluare :>> ', objEvaluare);


                    //creeaza evaluarea


                    let insertEvaluare = await this.wsC.insert('evaluari', objEvaluare)


                    if (insertEvaluare.Succes) {

                        let evaluareChestionar = {
                            id_evaluare: insertEvaluare.Content[0].id,
                            id_chestionar: this.state.chestionarSelectat
                        }



                        let departamente = [...this.state.departamente]

                        let evaluatori = []


                        for (let i = 0, n = departamente.length; i < n; i++) {

                            for (let j = 0, m = departamente[i].angajati.length; j < m; j++) {

                                if (departamente[i].angajati[j].selectat) {
                                    evaluatori.push(departamente[i].angajati[j])
                                }
                            }
                        }

                        console.log('evaluatori :>> ', evaluatori);


                        let insertLegaturaChestionarEvaluare = await this.wsC.insert('evaluari_chestionare', evaluareChestionar)

                        if (insertLegaturaChestionarEvaluare.Succes) {
                            for (let i = 0, n = evaluatori.length; i < n; i++) {




                                let objToAdd = {
                                    id_beneficiar: this.state.idSocietate,
                                    id_evaluare: insertEvaluare.Content[0].id,
                                    email: evaluatori[i].email,
                                    nume: evaluatori[i].nume,
                                    id_departament: evaluatori[i].id_departament,
                                    id_angajat: evaluatori[i].id
                                }
                                console.log('objToAdd :', objToAdd);

                                let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);

                                // console.warn('insert :>> ', insert);



                            }
                        }



                        // let insertEmailuri = 

                        //trimite email-uri

                        let sendEmails = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluare.Content[0].id, isFromPm: '1' })


                        console.log('sendEmails :>> ', sendEmails);
                        if (sendEmails.Succes) {
                            this.props.history.push(`/evaluarisesiune/${this.props.match.params.idsesiune}/evaluare_angajati`)
                        }



                        //creeaza legatura evaluare chestionar







                    }

                } else if (Number(this.state.tipEvaluare) === 2) {

                    let departamente = [...this.state.departamente]

                    let idx = departamente.findIndex(dep => dep.id === Number(this.state.departamentSelectat))

                    if (idx !== -1) {
                        console.log('departamente[idx] :>> ', departamente[idx]);

                        let counter = 0

                        for (let i = 0, n = departamente[idx].angajati.length; i < n; i++) {



                            let objEvaluare = {
                                id_beneficiar: this.state.idSocietate,
                                cand_creat: this.u.updateSqlNow(),
                                cine_creat: this.ls.InfoUser.IdUser,
                                denumire: "",
                                foloseste_puncte: 1,
                                id_sesiune: this.props.match.params.idsesiune,
                                id_user_aprobare: departamente[idx].angajati[i].id_user,
                                id_departament: departamente[idx].id,
                                statusul: "lansat",
                                tip: "evaluare_angajati"
                            }


                            console.log('objEvaluare :>> ', objEvaluare);


                            //creeaza evaluarea


                            let insertEvaluare = await this.wsC.insert('evaluari', objEvaluare)


                            if (insertEvaluare.Succes) {

                                let evaluareChestionar = {
                                    id_evaluare: insertEvaluare.Content[0].id,
                                    id_chestionar: this.state.chestionarSelectat
                                }



                                let departamente = [...this.state.departamente]

                                let evaluatori = []


                                for (let k = 0, m = departamente.length; k < m; k++) {

                                    for (let j = 0, o = departamente[k].angajati.length; j < o; j++) {

                                        if( Number(departamente[idx].angajati[i].id_user) !== Number(departamente[k].angajati[j].id_user)){
                                            if (departamente[k].angajati[j].selectat) {
                                                evaluatori.push(departamente[k].angajati[j])
                                            }
                                        }

                                        
                                    }
                                }

                                console.log('evaluatori :>> ', evaluatori);


                                let insertLegaturaChestionarEvaluare = await this.wsC.insert('evaluari_chestionare', evaluareChestionar)

                                if (insertLegaturaChestionarEvaluare.Succes) {
                                    for (let k = 0, l = evaluatori.length; k < l; k++) {




                                        let objToAdd = {
                                            id_beneficiar: this.state.idSocietate,
                                            id_evaluare: insertEvaluare.Content[0].id,
                                            email: evaluatori[k].email,
                                            nume: evaluatori[k].nume,
                                            id_departament: evaluatori[k].id_departament,
                                            id_angajat: evaluatori[k].id
                                        }
                                        console.log('objToAdd :', objToAdd);

                                        let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);

                                        // console.warn('insert :>> ', insert);



                                    }
                                }



                                // let insertEmailuri = 

                                //trimite email-uri

                                let sendEmails = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluare.Content[0].id, isFromPm: '1' })


                                console.log('sendEmails :>> ', sendEmails);
                                if (sendEmails.Succes) {

                                    counter += 1
                                    // this.props.history.push(`/evaluarisesiune/${this.props.match.params.idsesiune}/evaluare_angajati`)
                                }



                                //creeaza legatura evaluare chestionar







                            }





                        }

                        if (counter === departamente[idx].angajati.length) {

                            console.log('goToEvaluariColegi :>> ');
                            this.props.history.push(`/evaluarisesiune/${this.props.match.params.idsesiune}/evaluare_angajati`)
                        }


                    }

                } else {

                    let departamente = [...this.state.departamente]

                    let departamenteFilter = [...this.state.departamente]

                    console.log('departamente :>> ', departamente);

                    for (let i = 0, n = departamente.length; i < n; i++) {



                        for (let j = 0, m = departamente[i].angajati.length; j < m; j++) {


                            console.log('departamente[i] :>> ', departamente[i]);
                            let objEvaluare = {
                                id_beneficiar: this.state.idSocietate,
                                cand_creat: this.u.updateSqlNow(),
                                cine_creat: this.ls.InfoUser.IdUser,
                                denumire: "",
                                foloseste_puncte: 1,
                                id_sesiune: this.props.match.params.idsesiune,
                                id_user_aprobare: departamente[i].angajati[j].id_user,
                                id_departament: departamente[i].id,
                                statusul: "lansat",
                                tip: "evaluare_angajati"
                            }


                            // console.log('objEvaluare :>> ', objEvaluare);

                            let insertEvaluare = await this.wsC.insert('evaluari', objEvaluare)

                            if (insertEvaluare.Succes) {
                                let evaluareChestionar = {
                                    id_evaluare: insertEvaluare.Content[0].id,
                                    id_chestionar: this.state.chestionarSelectat
                                }

                                let evaluatori = []

                                let cloneUseri = JSON.parse(JSON.stringify(this.state.useri))

                                
                                cloneUseri = cloneUseri.filter(us => us.sef_departament !== 1)



                                let randomUseriDeprtament = cloneUseri.filter(us => us.id_departament === departamente[i].id)
                                randomUseriDeprtament = randomUseriDeprtament.filter(us => us.id_user !== departamente[i].angajati[j].id_user)

                                // console.log('randomUseriDeprtament :>> ', randomUseriDeprtament);

                                let randomUseriSelectati = []

                                if (randomUseriDeprtament.length > 2) {
                                    randomUseriSelectati = this.u.getRandomArray(randomUseriDeprtament, this.state.objMin.nr_useri_departament)
                                }else{
                                    randomUseriSelectati = randomUseriDeprtament
                                }

                                for (let k = 0, o = randomUseriSelectati.length; k < o; k++) {
                                    randomUseriSelectati[k].selectat = true
                                    evaluatori.push(randomUseriSelectati[k])
                                }

                              


                                let randomDepartamente = cloneUseri.filter(us => us.id_departament !== departamente[i].id)
                                console.log('randomDepartamente :>> ', randomDepartamente);

                                randomDepartamente = randomDepartamente.filter(rd => !rd.selectat)

                                let randomDepartamenteSelectati = []

                                let nrUseriDepartamente = this.state.objMin.nr_useri_departamente

                                if(randomUseriDeprtament.length < 2){
                                    nrUseriDepartamente = this.state.objMin.nr_useri_departamente + 2 - randomUseriDeprtament.length 
                                }

                                if(randomDepartamente.length > 4){

                                    randomDepartamenteSelectati = this.u.getRandomArray(randomDepartamente, nrUseriDepartamente)
                                }else{
                                    randomDepartamenteSelectati = randomDepartamente
                                }


                                console.log('randomDepartamenteSelectati :>> ', randomDepartamenteSelectati);

                                for (let k = 0, o = randomDepartamenteSelectati.length; k < o; k++) {
                                    randomDepartamenteSelectati[k].selectat = true

                                    let idxRU = evaluatori.findIndex(us => us.id_user === randomDepartamenteSelectati[k].id_user)

                                    if (idxRU === -1) {

                                        evaluatori.push(randomDepartamenteSelectati[k])
                                    }
                                }

                                console.log('evaluatori :>> ', evaluatori);

                                let insertLegaturaChestionarEvaluare = await this.wsC.insert('evaluari_chestionare', evaluareChestionar)

                                if (insertLegaturaChestionarEvaluare.Succes) {
                                    for (let k = 0, l = evaluatori.length; k < l; k++) {




                                        let objToAdd = {
                                            id_beneficiar: this.state.idSocietate,
                                            id_evaluare: insertEvaluare.Content[0].id,
                                            email: evaluatori[k].email,
                                            nume: evaluatori[k].nume,
                                            id_departament: evaluatori[k].id_departament,
                                            id_angajat: evaluatori[k].id
                                        }
                                        console.log('objToAdd :', objToAdd);

                                        let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);

                                        // console.warn('insert :>> ', insert);



                                    }

                                    let sendEmails = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluare.Content[0].id, isFromPm: '1' })


                                    console.log('sendEmails :>> ', sendEmails);
                                    if (sendEmails.Succes) {



                                    }


                                }



                            }












                        }


                    }

                    this.props.history.push(`/evaluarisesiune/${this.props.match.params.idsesiune}/evaluare_angajati`)

                }
            } else {




                let departamente = [...this.state.departamente]

                let evaluatori = []

                let emailuriEvaluare = [...this.state.emailuriEvaluare]


                for (let i = 0, n = departamente.length; i < n; i++) {

                    for (let j = 0, m = departamente[i].angajati.length; j < m; j++) {

                        if (departamente[i].angajati[j].selectat) {
                            evaluatori.push(departamente[i].angajati[j])
                        }
                    }
                }




                for (let i = 0, n = evaluatori.length; i < n; i++) {



                    let idx = emailuriEvaluare.findIndex(em => em.id_angajat === evaluatori[i].id)

                    console.log('idx :>> ', idx);

                    if (idx === -1) {
                        let objToAdd = {
                            id_beneficiar: this.state.idSocietate,
                            id_evaluare: this.state.evaluare.id,
                            email: evaluatori[i].email,
                            nume: evaluatori[i].nume,
                            id_departament: evaluatori[i].id_departament,
                            id_angajat: evaluatori[i].id
                        }

                        console.log('insert :>> ', objToAdd)

                        let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);
                    }






                    // console.warn('insert :>> ', insert);



                }




                // let insertEmailuri = 

                //trimite email-uri

                let sendEmails = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: this.state.evaluare.id, isFromPm: '1' })


                console.log('sendEmails :>> ', sendEmails);
                if (sendEmails.Succes) {
                    this.props.history.push(`/evaluarisesiune/${this.props.match.params.idsesiune}/evaluare_angajati`)
                }



                //creeaza legatura evaluare chestionar










            }
        })







    }


    testAlgoritm = () => {
        let departamente = [...this.state.departamente]

        let departamenteFilter = [...this.state.departamente]

        console.log('departamente :>> ', departamente);



        for (let i = 0, n = departamente.length; i < n; i++) {



            for (let j = 0, m = departamente[i].angajati.length; j < m; j++) {

                console.log('departamente[i] :>> ', departamente[i]);
                let objEvaluare = {
                    id_beneficiar: this.state.idSocietate,
                    cand_creat: this.u.updateSqlNow(),
                    cine_creat: this.ls.InfoUser.IdUser,
                    denumire: "",
                    foloseste_puncte: 1,
                    id_sesiune: this.props.match.params.idsesiune,
                    id_user_aprobare: departamente[i].angajati[j].id_user,
                    id_departament: departamente[i].id,
                    statusul: "lansat",
                    tip: "evaluare_angajati"
                }



                let evaluareChestionar = {
                    id_evaluare: '',
                    id_chestionar: this.state.chestionarSelectat
                }

                let evaluatori = []

                let cloneUseri = [...this.state.useri]


                let randomUseriDeprtament = cloneUseri.filter(us => us.id_departament === departamente[i].id)
                randomUseriDeprtament = randomUseriDeprtament.filter(us => us.id_user !== departamente[i].angajati[j].id_user)

                console.log('randomUseriDeprtament :>> ', randomUseriDeprtament);

                let randomUseriSelectati = []

                if (randomUseriDeprtament.length > 0) {
                    randomUseriSelectati = this.u.getRandomArray(randomUseriDeprtament, this.state.objMin.nr_useri_departament)
                }

                for (let k = 0, o = randomUseriSelectati.length; k < o; k++) {
                    randomUseriSelectati[k].selectat = true
                    evaluatori.push(randomUseriSelectati[k])
                }


                let randomDepartamente = cloneUseri.filter(us => us.id_departament !== departamente[i].id)
                console.log('randomDepartamente :>> ', randomDepartamente);

                let randomDepartamenteSelectati = this.u.getRandomArray(randomDepartamente, this.state.objMin.nr_useri_departamente)

                console.log('randomDepartamenteSelectati :>> ', randomDepartamenteSelectati);

                for (let k = 0, o = randomDepartamenteSelectati.length; k < o; k++) {
                    randomDepartamenteSelectati[k].selectat = true

                    let idxRU = evaluatori.findIndex(us => us.id_user === randomDepartamenteSelectati[k].id_user)

                    if (idxRU === -1) {

                        evaluatori.push(randomDepartamenteSelectati[k])
                    }
                }

                console.log('evaluatori :>> ', evaluatori);




                for (let k = 0, l = evaluatori.length; k < l; k++) {




                    let objToAdd = {
                        id_beneficiar: this.state.idSocietate,
                        id_evaluare: '',
                        email: evaluatori[k].email,
                        nume: evaluatori[k].nume,
                        id_departament: evaluatori[k].id_departament,
                        id_angajat: evaluatori[k].id
                    }
                    console.log('objToAdd :', objToAdd);

                    // let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);

                    // console.warn('insert :>> ', insert);



                }

                // let sendEmails = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluare.Content[0].id , isFromPm:'1'})


                // console.log('sendEmails :>> ', sendEmails);
                // if (sendEmails.Succes) {



                // }




            }
        }
    }





    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={''} appBarButtons={this.buildAppBarButtons()} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />


                {this.state.loading &&
                    <div className='loading-div' >

                        <CircularProgress
                            style={{
                                width: 60,
                                height: 60,
                                color: '#25e048',
                                marginTop: '40%'
                            }}
                            value={20}

                        />
                        <span style={{ display: 'block', fontSize: 20 }}>Loading...</span>
                    </div>
                }

                <Grid style={{ maxWidth: 1200, margin: 'auto' }} container>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.evaluari.evaluareColegi}</h1>
                    </Grid>

                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>


                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.evaluari.peCineEvaluezi}</h5>
                                </Grid>
                                <Grid style={{ marginBottom: 20, textAlign:'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            id='tip-evaluare'
                                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='tva'
                                            value={this.state.tipEvaluare}
                                            onChange={this.changeTipEvaluare}
                                            placeholder={this.dictionary.evaluari.alegeOptiune}
                                            disabled={Number(this.props.match.params.idevaluare) !== 0}
                                        >

                                            <option value={0}>{this.dictionary.evaluari.alegeOptiune}</option>
                                            {this.state.tipuriEvaluare.map((t, idx) => {
                                                return (
                                                    <option key={idx} value={t.id}>{t.nume}</option>
                                                )
                                            })}
                                        </select>
                                        <label  className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.selecteaza}</label>
                                    </div>
                                </Grid>

                                {Number(this.state.tipEvaluare) === 1 &&
                                    <Grid style={{ marginBottom: 10, textAlign:'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div>
                                            <CustomUserMenu
                                                user={this.state.userEvaluat}
                                                clearInput={() => {
                                                    this.setState({
                                                        userEvaluat: Number(this.props.match.params.idevaluare) !== 0 ?
                                                            this.state.userEvaluat :

                                                            {
                                                                id: null, poza: null
                                                            },
                                                        creeazaEvaluareDisabled: Number(this.props.match.params.idevaluare) !== 0 ? false : true
                                                    })
                                                }}
                                                openList={() => { this.setState({ openList: Number(this.props.match.params.idevaluare) !== 0 ? false : true }) }}
                                                closeList={() => { this.setState({ openList: false }) }}
                                                showList={this.state.openList}
                                                users={this.state.useri}
                                                selectUser={this.selectUser}

                                            />
                                        </div>

                                    </Grid>
                                }

                                {Number(this.state.tipEvaluare) === 2 &&
                                    <Grid style={{ marginBottom: 10, textAlign:'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative' }}>
                                            <select
                                                id='departament'
                                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='tva'
                                                value={this.state.departamentSelectat}
                                                onChange={this.changeDepartament}
                                                placeholder={this.dictionary.evaluari.alegeDepartament}
                                                disabled={Number(this.props.match.params.idevaluare) !== 0}
                                            >

                                                <option value={0}>{this.dictionary.evaluari.alegeDepartament}</option>
                                                {this.state.departamente.map((d, idx) => {
                                                    return (
                                                        <option key={idx} value={d.id}>{d.nume}</option>
                                                    )
                                                })}
                                            </select>
                                            <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.selecteaza}</label>
                                        </div>
                                    </Grid>
                                }

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.evaluari.formularEvaluare}</h5>
                                </Grid>
                                <Grid style={{ marginBottom: 10, textAlign:'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            id='chestionar'
                                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='tva'
                                            value={this.state.chestionarSelectat}
                                            onChange={this.changeChestionar}
                                            placeholder={this.dictionary.evaluari.alegeFormular}
                                            disabled={Number(this.props.match.params.idevaluare) !== 0}
                                        >

                                            <option value={0}>{this.dictionary.evaluari.alegeFormular}</option>
                                            {this.state.chestionare.map((d, idx) => {
                                                return (
                                                    <option key={idx} value={d.id}>{d.titlu}</option>
                                                )
                                            })}
                                        </select>
                                        <label  className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.alegeFormular}</label>
                                    </div>
                                </Grid>
                                <Grid style={{ marginBottom: 20, textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <span style={{ textAlign: 'left',  fontSize: 14 }} >
                                        <span onClick={this.goToChestionare} style={{ textDecoration: 'underline', cursor: 'pointer', color: 'rgb(25 87 169)' }}>{this.dictionary.evaluari.clickAici}</span> {this.dictionary.evaluari.administrareFormulare}</span>


                                </Grid>

                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button
                                        disabled={this.state.creeazaEvaluareDisabled}

                                        className={this.state.creeazaEvaluareDisabled ? 'add-button-disabled' : 'add-button-green'} onClick={this.addEvaluare}  >
                                     
                                     {this.dictionary.evaluari.creeazaEvaluarea}
                                </Button>
                                </Grid>

                            </Grid>
                        </Grid>


                        <Grid style={{ padding: '0px 40px 0px 40px' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                            {Number(this.state.tipEvaluare) < 3 &&
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.evaluari.selecteazaEvaluatori}</h5>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <ListaEvaluatori
                                            arataUseri={this.arataUseri}
                                            listaDepartamente={this.state.departamente}
                                            selecteazaDepartament={this.selecteazaDepartament}
                                            selecteazaAngajat={this.selecteazaAngajat}
                                            tip={'evaluari_angajati'}
                                        />
                                    </Grid>

                                    <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span><span style={{ fontWeight: 600 }}>{this.state.angajatiSelectati}</span> {this.dictionary.evaluari.din} {this.state.useri.filter(u => u.sef_departament !== 1).length}{this.dictionary.evaluari.evaluatoriSelectati} </span>
                                    </Grid>
                                </Grid>

                            }

                            {Number(this.state.tipEvaluare) === 3 &&
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5  className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.evaluari.evaluatori}</h5>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    </Grid>

                                    <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span>Sistemul a selectat {this.state.objMin.nr_useri_departament + this.state.objMin.nr_useri_departamente}{this.dictionary.evaluari.evaluatoriAlgoritm}  :</span>
                                    </Grid>
                                    <Grid style={{ textAlign: 'left', marginTop: 20, fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span style={{ display: 'block' }}>- {this.state.objMin.nr_useri_departament} {this.dictionary.evaluari.persoaneAcelasiDepartament}</span>
                                        <span style={{ display: 'block' }}>- {this.state.objMin.nr_useri_departamente} {this.dictionary.evaluari.persoaneLaIntamplare}</span>
                                    </Grid>
                                </Grid>

                            }
                        </Grid>

                        <Grid style={{ padding: '0px 40px 0px 40px' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                            {this.state.userEvaluat.id !== null && Number(this.state.tipEvaluare) === 1 &&
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.evaluari.dateAngajat}</h5>
                                    </Grid>
                                    <Grid style={{ textAlign: 'left', fontSize: 12, marginBottom:10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span> {this.dictionary.evaluari.numeAngajat}: <span style={{ fontWeight: 600 }}>{this.state.userEvaluat.nume}</span></span>
                                    </Grid>
                                    <Grid style={{ textAlign: 'left', fontSize: 12, marginBottom:10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span>{this.dictionary.evaluari.functieAngajat}: <span style={{ fontWeight: 600 }}>{this.state.userEvaluat.functie}</span></span>
                                    </Grid>
                                    <Grid style={{ textAlign: 'left', fontSize: 12, marginBottom:10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span>{this.dictionary.evaluari.departament}: <span style={{ fontWeight: 600 }}>{this.state.userEvaluat.nume_departament}</span></span>
                                    </Grid>
                                    <Grid style={{ textAlign: 'left', fontSize: 12, marginBottom:10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span>{this.dictionary.evaluari.colegiInDept}: <span style={{ fontWeight: 600 }}>{this.state.idxDepartament !== -1 ? this.state.departamente[this.state.idxDepartament].angajati.length : 0}</span></span>
                                    </Grid>



                                </Grid>
                            }


                            {this.state.departamentSelectat !== 0 && Number(this.state.tipEvaluare) === 2 &&
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.evaluari.dateDepartament}</h5>
                                    </Grid>
                                    <Grid style={{ textAlign: 'left', fontSize: 12, marginBottom:10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span>{this.dictionary.evaluari.numeAngajat}: <span style={{ fontWeight: 600 }}>{this.state.departamente[this.state.idxDepartament].nume}</span></span>
                                    </Grid>
                                    <Grid style={{ textAlign: 'left', fontSize: 12, marginBottom:10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span>{this.dictionary.evaluari.angajati}: <span style={{ fontWeight: 600 }}>{this.state.departamente[this.state.idxDepartament].angajati.length}</span></span>
                                    </Grid>




                                </Grid>
                            }





                            {this.state.ultimaEvaluare &&
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.evaluari.ultimaEvaluare}</h5>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left', fontSize: 12, marginBottom:10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span>{this.dictionary.evaluari.dataUltimaEvaluare}: <span style={{ fontWeight: 600 }}>{this.u.dataFull(this.u.ParseDataFromSql(this.state.ultimaEvaluare.cand_creat))}</span></span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left', fontSize: 12, marginBottom:10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span>{this.dictionary.evaluari.nrEvaluatori}: <span style={{ fontWeight: 600 }}>{this.state.ultimaEvaluare.nr_evaluatori}</span></span>
                                    </Grid>
                                </Grid>
                            }
                        </Grid>






                    </Grid>

                </Grid>
            </div >
        );
    }
}